/* eslint-disable no-unused-vars */
import { fabric } from "fabric";

import rotateSVG from "../assets/icons/rotate.svg";

fabric.Object.prototype.set({
  transparentCorners: false,
  borderColor: "#00bff3",
  cornerColor: "#00bff3",
});

/*
  OVERRIDE FABRIC CORNER CONTROLS
*/

fabric.Control.prototype.render = function(ctx, left, top, styleOverride, fabricObject) {
  styleOverride = styleOverride || {};

  if (this.actionName === "rotate") {
    styleOverride.cornerStyle = "image";
  } else if (this.actionName === "rotationAngle") {
    styleOverride.cornerStyle = "rotationAngle";
  }

  // prettier-ignore
  switch (styleOverride.cornerStyle || fabricObject.cornerStyle) {
		case "circle":
			fabric.controlsUtils.renderCircleControl.call(this, ctx, left, top, styleOverride, fabricObject);
			break;
		case "image":
			fabric.controlsUtils.renderImageControl.call(this, ctx, left, top, styleOverride, fabricObject);
      break;
    case "rotationAngle":
			fabric.controlsUtils.renderAngleDisplay.call(this, ctx, left, top, styleOverride, fabricObject);
			break;
		default:
			fabric.controlsUtils.renderSquareControl.call(this, ctx, left, top, styleOverride, fabricObject);
      break;
	}
};

// ROTATION ICON

fabric.Object.prototype.controls.mtr.cornerSize = 26;
fabric.Object.prototype.controls.mtr.offsetX = 0;
fabric.Object.prototype.controls.mtr.offsetY = -40;

var rotateIcon;
(function() {
  const rotate = new Image();

  rotate.onload = function() {
    rotateIcon = this;
  };

  rotate.src = rotateSVG;
})();

fabric.controlsUtils.renderImageControl = renderImageControl;

function renderImageControl(ctx, left, top, styleOverride, fabricObject) {
  const size = this.cornerSize;

  ctx.save();
  ctx.translate(left, top);
  ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));
  ctx.drawImage(rotateIcon, -size / 2, -size / 2, size, size);
  ctx.restore();
}

// CURRENT ROTATION ANGLE DISPLAY
fabric.Object.prototype.controls.rot = new fabric.Control({
  x: 0,
  y: -0.5,
  actionHandler: fabric.controlsUtils.rotationWithSnapping,
  cursorStyleHandler: fabric.controlsUtils.rotationStyleHandler,
  offsetY: -80,
  withConnection: false,
  actionName: "rotationAngle",
});

fabric.Object.prototype.showAngleDisplayControl = function(show) {
  this.setControlVisible("rot", show);
};

fabric.controlsUtils.renderAngleDisplay = renderAngleDisplay;

function renderAngleDisplay(ctx, left, top, styleOverride, fabricObject) {
  ctx.save();

  ctx.translate(left, top);
  ctx.rotate(fabric.util.degreesToRadians(fabricObject.angle));

  ctx.font = "20px Arial";
  const text = `${Math.round(fabricObject.angle)}\xB0`;
  const textSize = ctx.measureText(text);

  // prettier-ignore
  const rx = 5, ry = 5, w = 50, h = w, x = -w/2, y = -h, k = 1 - 0.5522847498;
  /* 
    FROM FABRIC SOURCE CODE 
    k = 1 - 0.5522847498 "magic number" for bezier approximations of arcs (http://itc.ktu.lt/itc354/Riskus354.pdf) 
  */

  ctx.beginPath();

  ctx.moveTo(x + rx, y);

  ctx.lineTo(x + w - rx, y);
  ctx.bezierCurveTo(x + w - k * rx, y, x + w, y + k * ry, x + w, y + ry);

  ctx.lineTo(x + w, y + h - ry);
  ctx.bezierCurveTo(x + w, y + h - k * ry, x + w - k * rx, y + h, x + w - rx, y + h);

  ctx.lineTo(x + rx, y + h);
  ctx.bezierCurveTo(x + k * rx, y + h, x, y + h - k * ry, x, y + h - ry);

  ctx.lineTo(x, y + ry);
  ctx.bezierCurveTo(x, y + k * ry, x + k * rx, y, x + rx, y);

  ctx.closePath();

  ctx.fillStyle = "#66CFF350";
  ctx.fill();

  ctx.fillStyle = "black";
  ctx.fillText(text, -textSize.width / 2, -(h - textSize.actualBoundingBoxAscent) / 2);

  ctx.restore();
}

/*
  END CONTROL OVERRIDE
*/

/*
  SVG OVERRIDE
*/
function getSvgColorString(prop, value) {
  if (!value) {
    return prop + ": none; ";
  } else if (value.toLive) {
    return prop + ": url(#SVGID_" + value.id + "); ";
  } else {
    var color = new fabric.Color(value),
      str = prop + ": " + color.toRgb() + "; ",
      opacity = color.getAlpha();
    if (opacity !== 1) {
      //change the color in rgb + opacity
      str += prop + "-opacity: " + opacity.toString() + "; ";
    }
    return str;
  }
}

fabric.Object.prototype.getSvgStyles = function(skipShadow) {
  const svgStyles = {
    stroke: getSvgColorString("stroke", this.stroke),
    strokeWidth: `stroke-width: ${this.strokeWidth ? this.strokeWidth : "0"}; `,
    strokeDashArray: `stroke-dasharray: ${
      this.strokeDashArray ? this.strokeDashArray.join(" ") : "none"
    }; `,
    strokeLineCap: `stroke-linecap: ${this.strokeLineCap ? this.strokeLineCap : "butt"}; `,
    strokeDashOffset: `stroke-dashoffset: ${this.strokeDashOffset ? this.strokeDashOffset : "0"}; `,
    strokeLineJoin: `stroke-linejoin: ${this.strokeLineJoin ? this.strokeLineJoin : "miter"}; `,
    strokeMiterLimit: `stroke-miterlimit: ${this.strokeMiterLimit ? this.strokeMiterLimit : "4"}; `,
    fill: getSvgColorString("fill", this.fill),
    fillRule: `fill-rule: ${this.fillRule ? this.fillRule : "nonzero"}; `,
    opacity: `opacity: ${typeof this.opacity !== "undefined" ? this.opacity : "1"}; `,
    filter: skipShadow ? "" : this.getSvgFilter(),
    visibility: this.visible ? "" : " visibility: hidden;",
  };

  const styles = [];
  const svgStylesToExclude = this.svgStylesToExclude || {};

  for (const style of Object.keys(svgStyles)) {
    if (!svgStylesToExclude[style]) {
      styles.push(svgStyles[style]);
    }
  }

  return styles.join("");
};
/*
  END SVG OVERRIDE
*/

/*
  OVERRIDES FROM FABRIC DOCS
*/

/**
 * Creates an instance of fabric.Image from its object representation
 * @static
 * @param {Object} object Object to create an instance from
 * @param {Function} callback Callback to invoke when an image instance is created
 */

fabric.Image.fromObject = function(object, callback) {
  fabric.util.loadImage(
    object.src,
    function(img, error) {
      if (error) {
        callback && callback(null, error);
        return;
      }
      fabric.Image.prototype._initFilters.call(object, object.filters, function(filters) {
        object.filters = filters || [];
        fabric.Image.prototype._initFilters.call(object, [object.resizeFilter], function(
          resizeFilters
        ) {
          object.resizeFilter = resizeFilters[0];
          if (typeof object.version === "undefined") {
            var elWidth = img.naturalWidth || img.width;
            var elHeight = img.naturalHeight || img.height;
            var scaleX = ((object.scaleX || 1) * object.width) / elWidth;
            var scaleY = ((object.scaleY || 1) * object.height) / elHeight;
            object.width = elWidth;
            object.height = elHeight;
            object.scaleX = scaleX;
            object.scaleY = scaleY;
          }
          var image = new fabric.Image(img, object);
          callback(image);
        });
      });
    },
    null,
    object.crossOrigin
  );
};

fabric.PathGroup = {};
fabric.PathGroup.fromObject = function(object, callback) {
  var originalPaths = object.paths;
  delete object.paths;
  if (typeof originalPaths === "string") {
    fabric.loadSVGFromURL(originalPaths, function(elements) {
      var pathUrl = originalPaths;
      var group = fabric.util.groupSVGElements(elements, object, pathUrl);
      group.type = "group";
      object.paths = originalPaths;
      callback(group);
    });
  } else {
    fabric.util.enlivenObjects(originalPaths, function(enlivenedObjects) {
      enlivenedObjects.forEach(function(obj) {
        obj._removeTransformMatrix();
      });
      var group = new fabric.Group(enlivenedObjects, object);
      group.type = "group";
      object.paths = originalPaths;
      callback(group);
    });
  }
};
